import {combineReducers} from 'redux'
import auth from './auth'
import interfaceComponents from './interface'
import i18n from './i18n'
import jobs from './jobs'
import task from './task'
import menuReducer from './menuReducer';

import funnel from '#app/redux/RTK/slices/funnelSlice';
import funnelUser from '#app/redux/RTK/slices/funnelUserSlice';
import clientPayments from "#app/redux/RTK/slices/clientPaymentsSlice";
import clientRatingsSliceReducer from '#app/redux/RTK/slices/clientRatingsSlice';
import settingsSliceReducer from '#app/redux/RTK/slices/settingsSlice';
import cacheReducer from '#app/redux/RTK/slices/cacheSlice';

export default () => combineReducers({ // @TODO всё, что можно увести в слайсы ртк, лучше увести в слайсы
    auth,
    jobs,
    interfaceComponents,
    i18n,
    task,
    funnel,
    funnelUser,
    clientPayments,
    clientRatings: clientRatingsSliceReducer,
    settings: settingsSliceReducer,
    cache: cacheReducer,
    menu: menuReducer,
})
